// ###### IMPORTS GENERAL
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// imports
import routes_web from "connections/routes_web";
import useViewportHeight from "services/useViewportHeight";

// ###### VIEW COMPONENT
const IndexLoad = () => {
  // ##### HOOKS
  useViewportHeight(); // Set real viewport height for mobile
  const navigate = useNavigate();

  // ##### OPTIMIZATION: Use React Router navigate instead of window.location.href
  // This prevents full page reload and works offline (SPA navigation)
  useEffect(() => {
    const is_PWAinstalled = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true;

    if (is_PWAinstalled) {
      navigate(routes_web.accounts_initial, { replace: true });
    } else {
      navigate(routes_web.pages_home, { replace: true });
    }
  }, [navigate]);

  // ###### RETURN VIEW
  return (
    <div
      className="w-full bg-gray-800 text-white"
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
    >      
      <div className="container mx-auto h-full flex items-center justify-center relative px-4">


        {/* Central content (image only) */}
        <div className="flex flex-col items-center justify-center relative">
          {/* Image Section */}
          <div
            className="w-64 h-64 bg-cover bg-center"
            style={{ backgroundImage: `url(${routes_web.img_logo_qapp_512})` }}
          ></div>

          {/* Spinner absolutely positioned with visual gap */}
          <div className="absolute bottom-[-2.5rem] border-4 border-gray-300 border-t-blue-500 rounded-full w-8 h-8 animate-spin"></div>
        </div>


      </div>
    </div>
  );
};

export default IndexLoad;
